export const FIRST_LAST_PATTERN = new RegExp("\\w \\w+");